import type { LLMMetadata } from "src/modules/ANNModule/ANNLLMAnalyzer";
import type { ServitutAnalysisFieldKey } from "src/modules/ANNModule/ANNServitutFieldAnnotations";
export type ServitutRedegoerelsePhase = "A" | "B";
import type { ServitutRow } from "./row";

export type ServitutMatrixColumnDetail = {
   matrikler: string[];
   ejerlav?: string;
   adresse?: string;
};

export type ServitutAktSearchHint = {
   indskannetAktDokumentId?: string | null;
};

export type ServitutLoadProgress = {
   stage: "registry" | "easements";
   completed: number;
   total: number;
};

export type ServitutExportProgress = {
   completedSteps: number;
   totalSteps: number;
   stage: "spreadsheet" | "document" | "compress" | "pdf";
   activeRowKey: string | null;
   documentIndex?: number;
   documentTotal?: number;
};

export type ServitutReportStatus = "idle" | "loading" | "ready" | "error";

export type ServitutReportState = {
   status: ServitutReportStatus;
   loadError?: string;
   loadProgress: ServitutLoadProgress | null;
   exportProgress: ServitutExportProgress | null;
   exporting: boolean;
   openingRowId: string | null;
   resolvingPaataleIds: string[];
   phase: ServitutRedegoerelsePhase;
   analysisField: ServitutAnalysisFieldKey;
   caseDescription: string;
   rows: Record<string, ServitutRow>;
   rowOrder: string[];
   columns: number[];
   columnLabels: Record<string, string>;
   columnDetails: Record<string, ServitutMatrixColumnDetail>;
   uniqueAktCount: number;
   metadataById: Record<string, LLMMetadata>;
   aktSearchByBfe: Record<string, ServitutAktSearchHint>;
   aktFetchIds: string[];
   justSavedIds: string[];
   unsavedIds: string[];
};

export function initialServitutReportState(
   options?: { phase?: ServitutRedegoerelsePhase; caseDescription?: string },
): ServitutReportState {
   return {
      status: "idle",
      loadProgress: null,
      exportProgress: null,
      exporting: false,
      openingRowId: null,
      resolvingPaataleIds: [],
      phase: options?.phase || "A",
      analysisField: "resume",
      caseDescription: options?.caseDescription || "",
      rows: {},
      rowOrder: [],
      columns: [],
      columnLabels: {},
      columnDetails: {},
      uniqueAktCount: 0,
      metadataById: {},
      aktSearchByBfe: {},
      aktFetchIds: [],
      justSavedIds: [],
      unsavedIds: [],
   };
}

export function orderedRows(state: ServitutReportState): ServitutRow[] {
   return state.rowOrder.map((id) => state.rows[id]).filter(Boolean);
}

export function replaceRow(state: ServitutReportState, row: ServitutRow): ServitutReportState {
   return {
      ...state,
      rows: { ...state.rows, [row.id]: row },
   };
}

export function mapRow(
   state: ServitutReportState,
   id: string,
   update: (row: ServitutRow) => ServitutRow,
): ServitutReportState {
   const current = state.rows[id];
   if (!current) {
      return state;
   }
   return replaceRow(state, update(current));
}
